import imgA from "../Images/Photos Site Fonciere/Lacroix/IMG_4046.JPG";
import imgB from "../Images/Photos Site Fonciere/Lacroix/IMG_4047.JPG";
import imgC from "../Images/Photos Site Fonciere/Lacroix/IMG_4048.JPG";
import imgD from "../Images/Photos Site Fonciere/Lacroix/IMG_4049.JPG";
import imgE from "../Images/Photos Site Fonciere/Lacroix/IMG_4050.JPG";
import imgF from "../Images/Photos Site Fonciere/Lacroix/IMG_4051.JPG";

//MALSHERBES

import imgAA from "../Images/Photos Site Fonciere/Malesherbes/IMG_1424.jpg";
import imgBB from "../Images/Photos Site Fonciere/Malesherbes/IMG_1426.jpg";
import imgCC from "../Images/Photos Site Fonciere/Malesherbes/IMG_1427.jpg";
import imgDD from "../Images/Photos Site Fonciere/Malesherbes/IMG_1428.jpg";
import imgEE from "../Images/Photos Site Fonciere/Malesherbes/IMG_1429.jpg";
import imgFF from "../Images/Photos Site Fonciere/Malesherbes/IMG_1434.jpg";
import imgGG from "../Images/Photos Site Fonciere/Malesherbes/IMG_1431.jpg";
import imgHH from "../Images/Photos Site Fonciere/Malesherbes/IMG_1415.jpg";
import imgII from "../Images/Photos Site Fonciere/Malesherbes/IMG_1433.jpg";

//Hell on earth

import imgJJ from "../Images/Photos Site Fonciere/Jules-Ferry/1er étage/IMG_2719.jpg";
import imgKK from "../Images/Photos Site Fonciere/Jules-Ferry/1er étage/IMG_2721.jpg";
import imgLL from "../Images/Photos Site Fonciere/Jules-Ferry/1er étage/IMG_2722.jpg";
import imgMM from "../Images/Photos Site Fonciere/Jules-Ferry/1er étage/IMG_2723.jpg";
import imgNN from "../Images/Photos Site Fonciere/Jules-Ferry/2ème étage/IMG_2707.jpg";
import imgOO from "../Images/Photos Site Fonciere/Jules-Ferry/2ème étage/IMG_2709.jpg";
import imgPP from "../Images/Photos Site Fonciere/Jules-Ferry/2ème étage/IMG_2703 (1).jpg";
import imgQQ from "../Images/Photos Site Fonciere/Jules-Ferry/2ème étage/IMG_2717.jpg";
import imgRR from "../Images/Photos Site Fonciere/Jules-Ferry/3-4-5ème étage Triplex/20200618_143142.jpg";
import imgSS from "../Images/Photos Site Fonciere/Jules-Ferry/3-4-5ème étage Triplex/20200618_143337.jpg";
import imgTT from "../Images/Photos Site Fonciere/Jules-Ferry/3-4-5ème étage Triplex/DSCN1699.JPG";
import imgWW from "../Images/Photos Site Fonciere/Jules-Ferry/3-4-5ème étage Triplex/DSCN1679.JPG"
import imgUU from "../Images/Photos Site Fonciere/Jules-Ferry/Exterieurs/20200618_133929.jpg";
import imgVV from "../Images/Photos Site Fonciere/Jules-Ferry/Parties communes/DSCN1689.JPG";




export const Pics = [
  {
    id: 1,
    img: imgA,
  },
  {
    id: 2,
    img: imgB,
  },
  {
    id: 3,
    img: imgC,
  },
  {
    id: 4,
    img: imgD,
  },
  {
    id: 5,
    img: imgE,
  },
  {
    id: 6,
    img: imgF,
  },
];


export const PicsMalsherbes = [
    {
      id: 1,
      img: imgAA,
    },
    {
      id: 2,
      img: imgBB,
    },
    {
      id: 3,
      img: imgCC,
    },
    {
      id: 4,
      img: imgDD,
    },
    {
      id: 5,
      img: imgEE,
    },
    {
      id: 6,
      img: imgFF,
    },
    {
      id: 7,
      img: imgGG,
    },
    {
      id: 8,
      img: imgHH,
    },
    {
      id: 9,
      img: imgII,
    },
  ];

  export const PicsJulesFerry = [
    {
      id: 1,
      img: imgJJ,
    },
    {
      id: 2,
      img: imgKK,
    },
    {
      id: 3,
      img: imgLL,
    },
    {
      id: 4,
      img: imgMM,
    },
    
    
    
  ];
  export const PicsJulesFerry2ndFloor = [
    {
      id: 1,
      img: imgNN,
    },
    {
      id: 2,
      img: imgOO,
    },
    {
      id: 3,
      img: imgPP,
    },
    {
      id: 4,
      img: imgQQ,
    },
    
    
    
  ];
  export const PicsJulesFerryTriplex = [
    {
      id: 1,
      img: imgRR,
    },
    {
      id: 2,
      img: imgSS,
    },
    {
      id: 3,
      img: imgTT,
    },
    {
      id: 4,
      img: imgWW,
    },
    
    
    
  ];


  export const PicsOperation = [
    {
    id:"A",
    img:imgHH,
    imageLink:"Operations/Malsherbes",
    name:"Malsherbes"
  },
    {
    id:"B",
    img:imgF,
    imageLink:"Operations/Lacroix",
    name:"Lacroix"
  },
    {
    id:"C",
    img:imgUU,
    imageLink:"Operations/JulesFerry",
    name:"Ferry"
  }
]